/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

export type PublisherInfoObjectType = 'advertiser' | 'lineItem' | 'order';

const PATHS: Record<PublisherInfoObjectType, string> = {
  advertiser: 'advertiser',
  lineItem: 'lineitem',
  order: 'order'
};

@Injectable({providedIn: 'root'})
export class PublisherInfoApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(type: PublisherInfoObjectType, id: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['publisherinfo', PATHS[type]]),
      params: {[type]: id}
    });
  }
}
